import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-64" data-mp="aua4y8rf39qx">
      <SectionHeading eyebrow="Exclusive professional bonuses — included free" title={<>
            <em className="text-brand" data-id="element-66" data-mp="1u59mwzi01t4">5 Additional Resources</em> to Help You Put the Pathway Into Practice
          </>} data-id="element-65" data-mp="ftwn8wm3rg6l" />
      <p className="mx-auto mt-5 max-w-2xl text-center text-[17px] leading-relaxed text-muted" data-id="element-67" data-mp="5xbf42esdoyj">
        These five bonuses complement the six core volumes by giving you additional tools for organizing information, reviewing cases, and
        practicing your reasoning.
      </p>

      <div className="mx-auto mt-12 max-w-6xl space-y-14 sm:space-y-20" data-id="element-68" data-mp="1mbjoevajq1s8">
        {bonuses.map((b, i) => <article key={b.number} className="grid grid-cols-1 items-center gap-6 lg:grid-cols-2 lg:gap-12" data-id="element-69" data-mp="1r8td28q429f0" data-mpi={i}>
            <div className={i % 2 === 1 ? 'lg:order-2' : ''} data-id="element-70" data-mp="3iclo5tyzymyv">
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} loading="lazy" className="-mx-4 block w-[calc(100%+2rem)] max-w-none sm:mx-0 sm:w-full sm:max-w-full" data-id="element-71" data-mp="3dg4vcmgurkfg" />
            </div>

            <div data-id="element-72" data-mp="2zfamy3tt1jgs">
              <span className="inline-flex items-center gap-2 rounded-full bg-brand px-3.5 py-1.5 text-[13px] font-extrabold uppercase tracking-wider text-white" data-id="element-73" data-mp="2zesjam4tc2yu">
                <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-74" data-mp="2uiu0rf661f6c" />
                Bonus #{b.number}
              </span>
              <h3 className="mt-4 text-balance font-serif text-[27px] font-extrabold leading-tight text-ink sm:text-[34px]" data-id="element-75" data-mp="33hfhr5vzom50">{b.title}</h3>
              <p className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-[15px]" data-id="element-76" data-mp="noqax9bp4d62">
                <span className="text-muted" data-id="element-77" data-mp="iq560wli15ba">Suggested reference value:</span>
                <span className="font-bold text-red-600 line-through" data-id="element-78" data-mp="3cjppr3dtl2q7">{b.value}</span>
                <span className="rounded-md bg-cta px-2 py-0.5 text-[13px] font-extrabold uppercase text-white" data-id="element-79" data-mp="3hhr97pf5r427">Included free</span>
              </p>

              <div className="mt-5 space-y-3 text-[16px] leading-relaxed text-muted sm:text-[17px]" data-id="element-80" data-mp="3lk4g4h5n580k">
                {b.intro.map(p => <p key={p} data-id="element-81" data-mp="2tsosqkw9fh9a">{p}</p>)}
              </div>

              <ul className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-82" data-mp="2tqc3rns346mq">
                {b.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-83" data-mp="32t3ibwg9biil">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-84" data-mp="32rs9vjbv9ml5" />
                    <span className="text-[15px] leading-snug text-ink" data-id="element-85" data-mp="37l4p52unoh18">{item}</span>
                  </li>)}
              </ul>

              <p className="mt-5 rounded-2xl bg-white px-4 py-4 text-[15px] font-semibold leading-relaxed text-ink" data-id="element-86" data-mp="2f30qnhg98eki">{b.closing}</p>
            </div>
          </article>)}
      </div>

      <CTAButton className="mt-14" label="Yes, I want all 5 bonuses" data-id="element-87" data-mp="22l6fhkculo4w" />
    </section>;
}